export default {
    CREATE_TENANT_SUCCESS: "Tenant created successfully.",
    UPDATE_TENANT_SUCCESS: "Tenant updated successfully.",
    CREATE_CLIENT_SUCCESS: "Client created successfully.",
    UPDATE_CLIENT_SUCCESS: "Client updated successfully.",
    UPDATE_CLIENT_FAILED: "Client updation failed.",
    CREATE_CLIENT_FAILED: "Client creation failed.",
    UPDATE_TENANT_FAILED: "Tenant updation failed.",
    SAVE_USER_SUCCESS: "Users created.",
    SAVE_USER_FAILED: "User creation failed.",
    SAVE_PRODUCT_SUCCESS: "Product Details Saved.",
    SAVE_PRODUCT_FAILED: "Error saving product details.",
    SAVE_ADDON_SUCCESS: "Addon details saved",
    SAVE_ADDON_FAILED: "Failed to save addon details",
    SAVE_VENDOR_SUCCESS: "Vendor details saved",
    SAVE_VENDOR_FAILED: "Failed to save vendor details",
    TENANT_REMOVED: "Tenant Deleted Successfully ",
    SAVE_SAAS_SUCCESS: "SAAS details saved.",
    TENANT_ACTIVATED: "Tenant activated successfully.",
    TENANT_DEACTIVATED: "Tenant deactivated successfully.",
    CLIENT_ACTIVATED: "Client activated successfully.",
    CLIENT_DEACTIVATED: "Client deactivated successfully.",
    CONNECTION_SUCCESS: "Connection Successful",
    CONNECTION_FAILED: "Connection Failed.",
    USER_EMAIL_EXISTS: "User with given email already exists.",
    SAVE_DATABASE_SUCCESS: "Database Details Saved.",
    RESOLVE_ERRORS: "Please resolve the errors",
    TENANT_DETAILS_ERROR:"Fill the Tenant Details",
    USER_ROLE_ERROR:"Fill the User Details",
    PRODUCT_SELECTION_ERROR:'Fill the Product & Package Details',
    TENANT_SAVE_ERROR:'Fill all the required fields'
}